import React, { useState } from 'react'
import './login.css'
import axios from 'axios';

const baseURL = localStorage.getItem('baseURL')

function Login({setIsLoggedIn}) {

    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    function handleEmail(e){
        setEmail(e.target.value);
    }

    function handlePass(e){
        console.log("setPass")
        setPass(e.target.value);
    }

    function login(e){
        e.preventDefault();
        if (email.length==0 || pass.length==0){
            console.log(`${email}\t${pass}`)
            window.alert("Enter valid email and password");
            return;
        } else {
            axios.post(baseURL+'/bt/login', {
                user: {
                    email: email,
                    pass: pass
                }
            }).then(response => {
                console.log(response)
                if (response.status!=200){
                    window.alert("Wrong Credentials");
                    console.log(response);
                } else {
                    setIsLoggedIn(true);
                    localStorage.setItem('authToken', `BEARER ${response.data.accessToken}`)
                    // console.log(response.data.accessToken)
                    window.alert("Logged In")
                }
            }).catch(err=>{
                console.log(err);
                window.alert("Wrong Credentials");
            })
        }
    }

  return (
    <section class="login">
        <div class="login-left">
            <h1>Login</h1>
            <form action="">
                <div>
                    <label>Email Id</label>
                    <input onChange={handleEmail} type="email" />
                </div>
                <div>
                    <label>Password</label>
                    <input onChange={handlePass} type="password" />
                </div>
                <button onClick={login} type="submit" class="primary-btn">Login</button>
            </form>
        </div>
        <div class="login-right">
        </div>
    </section>
  )
}

export default Login